import React, { useState} from 'react';
import { useFormik } from 'formik';
import { camelizeKeys, decamelizeKeys } from 'humps';
import * as Yup from 'yup';
import { Button } from '../Button/Button';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import cx from 'classnames';

export const StatusEditModal = ({ order, statuses, onModalClose, isOpen, onStatusChange = () => {} }) => {
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      statusId: order.status.id,
    },
    initialStatus: {},
    validationSchema: Yup.object({
      statusId: Yup.number().required('Required'),
    }),
    onSubmit: async (values, formik) => {
      setIsLoading(true);
      formik.setStatus({});
      try {
        const response = await fetch(`/admin/orders/set-status/${order.id}`, {
          method: 'PUT',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          },
          body: JSON.stringify(decamelizeKeys(values)),
        });

        const data = await response.json();

        if (!response.ok) {
          formik.setStatus({ error: data.message ?? __('app.error') });
          setIsLoading(false);
          return;
        }

        setIsLoading(false);
        onStatusChange(camelizeKeys(data));
        onModalClose();
      } catch (error) {
        setIsLoading(false);
        formik.setStatus({ error: __('app.error')});
      }
    },
  });

  const filteredStatuses = statuses.filter(status => status.type === order.type)

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader toggle={onModalClose}>{__('statuses.change')}</ModalHeader>
      <form>
        <ModalBody>
          <select
            className={cx('form-control', {
              'is-invalid': formik.errors.statusId && formik.touched.statusId,
            })}
            id="statusId"
            name="statusId"
            value={formik.values.statusId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            {filteredStatuses.map((status) => (
              <option key={status.id} value={status.id}>
                {status.name}
              </option>
            ))}
          </select>
          {formik.status.error && (
            <div className="invalid-feedback d-block">{formik.status.error}</div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button className="btn-primary" onClick={formik.submitForm} disabled={isLoading}>
            {__('app.submit')}
          </Button>
          <Button className="btn-secondary" onClick={onModalClose}>
            {__('app.back')}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
